import StoreModuleService from '../StoreModuleService';
import { MODULE_NAME } from './const';

const buildWidgetGetterObject = (getter) => StoreModuleService.buildGetterObject(MODULE_NAME, getter);

// getters declarations
export const data = buildWidgetGetterObject('data');
export const getWidget = buildWidgetGetterObject('getWidget');
export const getWidgetFieldData = buildWidgetGetterObject('getWidgetFieldData');

const getters = {
	[data.getter]: (state) => state.data,
	[getWidget.getter]: (state) => (widgetId) => state.data[widgetId],
	[getWidgetFieldData.getter]: (state) => (widgetFieldUUID) => {
		for (const widget of Object.values(state.data)) {
			const field = widget?.fields?.find((field) => field.id === widgetFieldUUID);
			if (field) {
				return { widgetField: field, widget };
			}
		}
		return {};
	},
};

export default getters;
